'use strict';

require("core-js/modules/es6.string.repeat");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.object.entries");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.roundPx = exports.getRect = exports.ThemeProvider = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

exports.withStyles = withStyles;
exports.ShortcutsWrapper = ShortcutsWrapper;
exports.getConfig = getConfig;
exports.findInterface = findInterface;
exports.getTextSize = getTextSize;
exports.getColor = getColor;
exports.getNumberKey = getNumberKey;
exports.getKeyName = getKeyName;
exports.replaceWs = replaceWs;
exports.replaceWsChar = replaceWsChar;
exports.flattenArray = flattenArray;
exports.invertObject = invertObject;
exports.isObject = isObject;
exports.range = range;
exports.insertInto = insertInto;
exports.getPointerPosition = getPointerPosition;
exports.getRelativePointerPosition = getRelativePointerPosition;
exports.checkIntersection = checkIntersection;
exports.pointsToRect = pointsToRect;
exports.rectToPoints = rectToPoints;
exports.getCenter = getCenter;
exports.getContrastColor = getContrastColor;
exports.getAlphaColor = getAlphaColor;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactShortcuts = require('react-shortcuts');

var _reactJss = require('react-jss');

var _reactJss2 = _interopRequireDefault(_reactJss);

var _chromaJs = require('chroma-js');

var _chromaJs2 = _interopRequireDefault(_chromaJs);

var _constants = require('./constants');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
/**
 * Custom namespaced theme provider
 */


var theming = (0, _reactJss.createTheming)(_constants.PRODIGY_UI_THEME);
var ThemeProvider = theming.ThemeProvider;
exports.ThemeProvider = ThemeProvider;

function withStyles(styles) {
  return (0, _reactJss2["default"])(styles, {
    theming: theming
  });
}
/**
 * Only apply shortcuts wrapper to component if shortcuts are available
 * in context. Used as component
 * @param {Object} props - The component props.
 * @returns {ReactComponent} – The wrapped component or the children.
 */


function ShortcutsWrapper(_ref) {
  var children = _ref.children,
      ctx = _ref.ctx,
      props = _objectWithoutProperties(_ref, ['children', 'ctx']);

  return !ctx ? _react2["default"].createElement('div', {
    className: props.className
  }, children) : _react2["default"].createElement(_reactShortcuts.Shortcuts, props, children);
}

function defaultIfUndefined(obj, defaultValue) {
  return typeof obj !== 'undefined' && obj != null ? obj : defaultValue;
}
/**
 * Get interface configuration from state
 * @param {Object} config – The current Prodigy configuration.
 * @returns {Object} - The config mapped to internal variables.
 */


function getConfig(globalConfig, task) {
  var taskConfig = task ? task.config || {} : {};

  var config = _extends({}, globalConfig, taskConfig);

  return {
    buttons: config.buttons || _constants.BUTTONS,
    labels: config.labels || [_constants.NO_LABEL],
    labelColors: config.custom_theme && config.custom_theme.labels ? config.custom_theme.labels : {},
    writingDir: config.writing_dir || 'ltr',
    diffStyle: config.diff_style || 'words',
    htmlTemplate: config.html_template,
    javascript: config.javascript,
    userConfig: config.user_config || {},
    hideTaskMeta: config.hide_meta || false,
    showFlag: config.show_flag || false,
    showWhitespace: config.show_whitespace || false,
    honorTokenWhitespace: config.honor_token_whitespace || true,
    hideNewlines: config.hide_newlines || config.hide_true_newline_tokens || false,
    allowNewlineHighlight: config.allow_newline_highlight || false,
    manualHighlight: config.ner_manual_require_click || false,
    labelStyle: config.ner_manual_label_style || 'list',
    highlightChars: defaultIfUndefined(config.ner_manual_highlight_chars, false),
    cardStyle: config.card_css || {},
    choiceStyle: config.choice_style || 'single',
    choiceAutoAccept: config.choice_auto_accept || false,
    darkenImage: config.darken_image || 0,
    showCenter: config.show_bounding_box_center || false,
    previewBoxes: config.preview_bounding_boxes || false,
    shadeBoxes: config.shade_bounding_boxes || false,
    clickBoxes: config.click_boxes || false,
    blocks: config.blocks || [],
    labelKeymap: config.keymap_by_label || {},
    audioCursor: defaultIfUndefined(config.show_audio_cursor, true),
    audioCursorTime: defaultIfUndefined(config.show_audio_cursor_time, true),
    audioTimeline: defaultIfUndefined(config.show_audio_timeline, false),
    audioMinimap: defaultIfUndefined(config.show_audio_minimap, true),
    audioBarWidth: defaultIfUndefined(config.audio_bar_width, 3),
    audioBarHeight: defaultIfUndefined(config.audio_bar_height, 2),
    audioBarGap: defaultIfUndefined(config.audio_bar_gap, 2),
    audioBarRadius: defaultIfUndefined(config.audio_bar_radius, 2),
    audioMaxZoom: defaultIfUndefined(config.audio_max_zoom, 5000),
    audioAutoplay: defaultIfUndefined(config.audio_autoplay, false),
    audioLoop: defaultIfUndefined(config.audio_loop, false),
    audioRate: defaultIfUndefined(config.audio_rate, 1.0),
    wrapRelations: defaultIfUndefined(config.wrap_relations, false),
    showRelationsLabels: defaultIfUndefined(config.show_relations_labels, true),
    hideRelationArrow: defaultIfUndefined(config.hide_relations_arrow, false),
    relationsSpanLabels: config.relations_span_labels || [],
    imageManualLegacy: defaultIfUndefined(config.image_manual_legacy, false),
    imageManualModes: defaultIfUndefined(config.image_manual_modes, _constants.IMAGE_MANUAL_MODES),
    imageManualStrokeWidth: defaultIfUndefined(config.image_manual_stroke_width, 4),
    imageManualFontSize: defaultIfUndefined(config.image_manual_font_size, 14),
    imageManualFromCenter: defaultIfUndefined(config.image_manual_from_center, false),
    imageManualShowLabels: defaultIfUndefined(config.image_manual_show_labels, true)
  };
}
/**
 * Find best-matching UI interface for a task
 * @param {Object} task - The annotation task.
 * @returns {string} - The best-matching view ID.
 */


function findInterface(task) {
  if (typeof task === 'string') return task;
  if (task.reject) return 'compare';
  if (task.options) return 'choice';
  if (task.image && task.spans) return 'image';
  if (task.label) return 'classification';
  if (task.audio) return 'audio';
  if (task.arcs) return 'dep';
  if (task.html) return 'html';
  if (task.image) return 'image';
  if (task.spans && task.text) return 'ner';
  return 'text';
}
/**
 * Get best text size based on card text
 * @param {string} text - The annotation task text.
 * @param {Object} sizes - Text sizes (sm, md) mapped to character counts.
 * @returns {string} - 'small', 'medium' or 'large'
 */


function getTextSize() {
  var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var sizes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    sm: 100,
    md: 25
  };
  if (!text || text.length > sizes.sm) return 'small';else if (text.length > sizes.md) return 'medium';else return 'large';
}
/**
 * Get color based on item index
 * @param {Array} colors – A list of colors.
 * @param {number} i - The item index.
 * @returns {string} - A color from the list.
 */


function getColor(colors, i) {
  return colors[i - Math.floor(i / colors.length) * colors.length];
}
/**
 * Get choice from keyCode – make sure shift+number maps to number + 10,
 * and alt+shift+number maps to number + 10. Also resolve 0 to 10.
 * @param {Event} ev - The keydown event.
 * @returns {number} - The number that was selected.
 */


function getNumberKey(ev) {
  var key = ev.key,
      keyCode = ev.keyCode,
      shiftKey = ev.shiftKey,
      altKey = ev.altKey;
  var charString = parseInt(String.fromCharCode(keyCode));

  if (shiftKey && altKey && key != charString) {
    return key == 0 ? 30 : 20 + charString;
  }

  if (shiftKey && key != charString) {
    return key == 0 ? 20 : 10 + charString;
  }

  return key == 0 ? 10 : key;
}
/**
 * Given the keyboard shortcuts context and keymap name, get a string of the
 * keyboard shortcuts for a given action. Used to display corresponding
 * actions in button tooltips etc.
 */


function getKeyName(ctx, keymap, id) {
  if (!ctx || !ctx.shortcuts) return null;
  var ctxKeymap = ctx.shortcuts._keymap || {};
  var keys = ctxKeymap[keymap] || {};
  var key = keys[id] || [];
  return key.length ? key.join(', ') : null;
}
/**
 * Replace whitespace in text with unicode icons
 * @param {string} text - The original text.
 * @returns {string} The text with whitespace indicators.
 */


function replaceWs(text) {
  return text.replace(/\n/g, '↵ ').replace(/\t/g, '⇥ ');
}
/**
 * Replace whitespace in text with character component wrapper
 * @param {string} text - The original text.
 * TODO
 */


function replaceWsChar(text, Char) {
  var showWhitespace = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if (!showWhitespace) {
    return text;
  }

  return text.split('').map(function (_char, i) {
    return _char == ' ' ? _react2["default"].createElement(Char, {
      key: i
    }, '\xB7') : _char == '\n' ? _react2["default"].createElement(Char, {
      key: i
    }, "\u21B5 ", _react2["default"].createElement('br', null)) : _char == '\t' ? _react2["default"].createElement(Char, {
      key: i
    }, "\u21E5") : _char;
  });
}
/**
 * Get rectangle based on two coordinates
 */


var getRect = exports.getRect = function getRect(a, b) {
  return [[a[0], a[1]], [a[0], b[1]], [b[0], b[1]], [b[0], a[1]]];
};
/**
 * Round pixels
 */


var roundPx = exports.roundPx = function roundPx(px) {
  var factor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
  return Math.round(px * factor) / factor;
};
/**
 * Replace with Array.prototype.flat once that's stable / has a Babel polyfill
 */


function flattenArray(arr) {
  return [].concat.apply([], arr);
}
/**
 * Invert object
 */


function invertObject(obj) {
  var result = {};
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = Object.entries(obj)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var _ref2 = _step.value;

      var _ref3 = _slicedToArray(_ref2, 2);

      var key = _ref3[0];
      var value = _ref3[1];
      result[value] = key;
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator["return"]) {
        _iterator["return"]();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return result;
}
/**
 * Check if variable is object
 * https://stackoverflow.com/a/8511350/6400719
 */


function isObject(obj) {
  return (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object' && obj !== null;
}
/**
 * Create a range, equivalent of Python's range
 */


function range(start, end) {
  return Array.from('x'.repeat(end - start), function (_, i) {
    return start + i;
  });
}
/**
 * Insert an item into an array at a specific position
 */


function insertInto(arr, item, index) {
  if (arr.length - 1 <= index || index === -1) return [].concat(_toConsumableArray(arr), [item]);
  return [].concat(_toConsumableArray(arr.slice(0, index)), [item], _toConsumableArray(arr.slice(index)));
}
/**
 * Get the absolute and relative pointer positions on a Konva node
 */


function getPointerPosition(node) {
  return node.getStage().getPointerPosition();
}

function getRelativePointerPosition(node) {
  var transform = node.getAbsoluteTransform().copy();
  transform.invert();
  var pos = getPointerPosition(node);
  return transform.point(pos);
}
/**
 * Check whether two nodes intersect
 */


function checkIntersection(r1, r2) {
  return !(r2.x > r1.x + r1.width || r2.x + r2.width < r1.x || r2.y > r1.y + r1.height || r2.y + r2.height < r1.y);
}
/**
 * Convert [[x1, y1], [x2, y2]] points to x, y, width, height rect
 */


function pointsToRect(_ref4) {
  var _ref5 = _slicedToArray(_ref4, 2),
      _ref5$ = _slicedToArray(_ref5[0], 2),
      x1 = _ref5$[0],
      y1 = _ref5$[1],
      _ref5$2 = _slicedToArray(_ref5[1], 2),
      x2 = _ref5$2[0],
      y2 = _ref5$2[1];

  var width = x1 > x2 ? x1 - x2 : x2 - x1;
  var height = y1 > y2 ? y1 - y2 : y2 - y1;
  var x = Math.min(x1, x2);
  var y = Math.min(y1, y2);
  return {
    width: width,
    height: height,
    x: x,
    y: y,
    center: getCenter({
      width: width,
      height: height,
      x: x,
      y: y
    })
  };
}
/**
 * Convert a rect of x, y, width, height to [[x1, y1], [x2, y2]] points
 */


function rectToPoints(_ref6) {
  var width = _ref6.width,
      height = _ref6.height,
      x = _ref6.x,
      y = _ref6.y;
  return [[x, y], [x, y + height], [x + width, y + height], [x + width, y]];
}
/**
 * Get the center of a rectanble
 */


function getCenter(_ref7) {
  var width = _ref7.width,
      height = _ref7.height,
      x = _ref7.x,
      y = _ref7.y;
  return [x + width / 2, y + height / 2];
}
/**
 * Get a contrasting (text) color for a given color
 * @param {string} color - The base color.
 * @param {string} light - The light contrast color option.
 * @param {string} dark - The dark contrast color option.
 */


function getContrastColor(color) {
  var light = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '#fff';
  var dark = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '#000';

  var contrastLight = _chromaJs2["default"].contrast(color, light);

  var contrastDark = _chromaJs2["default"].contrast(color, dark);

  return contrastLight > contrastDark ? light : dark;
}
/**
 * Lighten a color
 */


function getAlphaColor(color, alpha) {
  // TODO: return rgba instead?
  return (0, _chromaJs2["default"])(color).alpha(alpha).css();
}